import React from "react";
import Navbar from "../../common/Navbar/Navbar";
import Main from "./Main";

function NewAlertsPage() {
  return (
    <div>
      <Navbar>
        <Main />
      </Navbar>
    </div>
  );
}

export default NewAlertsPage;
